import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/boldplay/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, boldplaySettings) {
    await Vue.http.post(`/api/boldplay/settings/byclient/${clientId}`, boldplaySettings);
    noty.success('Settings saved successfully');
  }
}



// WEBPACK FOOTER //
// ./src/services/boldplay.service.js